import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { FieldConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-config.interface';
import { OnFieldChanged } from '@ordersnproducts/modules/shared/modules/configurable-form/models/on-field-changed';
import { getUnloadTimes } from '../../../rms-specification/selectors/single-catalogs';
import { filter, take } from 'rxjs/operators';
import { LoadUnloadTimeFilteredCompleteAction } from '../../../rms-specification/actions/single-catalogs.actions';
import { FeatureToggleService } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '@ordersnproducts/features';
import { UNLOAD_TYPE_MIN_TIMES_MAP } from '../../constants/unload-type-min-times-map';
import { ImUnloadTime } from '@cemex-core/cmx-api';

@Injectable()
export class FilterUnloadTimesCommand implements OnFieldChanged {
  constructor(
    private store: Store<OrderBuilderState>,
    private featureToggleService: FeatureToggleService,
  ) {}

  onFieldChanged(
    value: any,
    formGroup: FormGroup,
    form: ConfigurableFormComponent | null,
    config?: FieldConfig,
    prev?: any,
  ): void {
    if (!value) {
      return;
    }
    if (!this.featureToggleService.isFeatureEnabled(Features.UNLOAD_TYPE_AND_APPLICATION_CATALOGUES_HOMOLOGATION)) {
      return;
    }

    this.store
      .select(getUnloadTimes)
      .pipe(
        filter((data) => data.length > 0),
        take(1),
      )
      .subscribe((unloadTimes: ImUnloadTime[]) => {
        const minUnloadTime = UNLOAD_TYPE_MIN_TIMES_MAP[value];
        const filteredUnloadTimes = unloadTimes.filter((time) => time.unloadTimeMinutes >= minUnloadTime);
        this.store.dispatch(new LoadUnloadTimeFilteredCompleteAction(filteredUnloadTimes));
      });
  }
}
